import {
  NOTES_GET,
  NOTE_ADD,
  NOTE_GET,
  NOTE_EDIT,
  NOTE_UPLOADFILE,
  NOTE_DELETE,
  NOTE_RESET_SEARCH,
} from './reduxConstant';
import { createReducer } from '../../../../app/common/utilities/reducerUtils';

const initialState = {
  total: 0,
  search: {
    year: '',
    sem: '',
    jenjang: '',
    tingkat: '',
    kelas: '',
    pelajaran: '',
    published: 'all',
  },
  items: [],
  uploadStatus: 'finish',
};

const notesGet = (state, payload) => {
  const notes = payload.notes;
  let total = notes?.total;
  let items = notes?.items;
  let search = notes?.search;

  return {
    ...state,
    total,
    items,
    search,
  };
};

const noteAdd = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) + 1,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.note.id + ''),
      payload.note,
    ],
  };
};

const noteGet = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.note.id + ''),
      payload.note,
    ],
  };
};

const noteEdit = (state, payload) => {
  return {
    ...state,
    items: [
      ...state.items.filter((i) => i.id + '' !== payload.note.id + ''),
      payload.note,
    ],
  };
};

const noteUploadFile = (state, payload) => {
  let status = payload.status;
  return {
    ...state,
    uploadStatus: status,
  };
};

const noteDelete = (state, payload) => {
  return {
    ...state,
    total: parseInt(state.total) - 1,
    items: [...state.items.filter((i) => i.id + '' !== payload.note.id + '')],
    search: { ...state.search },
  };
};

const noteResetSearch = (state, payload) => {
  return {
    ...state,
    search: {
      year: '',
      sem: '',
      jenjang: '',
      tingkat: '',
      kelas: '',
      pelajaran: '',
      published: 'all',
    },
  };
};

export default createReducer(initialState, {
  [NOTES_GET]: notesGet,
  [NOTE_ADD]: noteAdd,
  [NOTE_GET]: noteGet,
  [NOTE_EDIT]: noteEdit,
  [NOTE_UPLOADFILE]: noteUploadFile,
  [NOTE_DELETE]: noteDelete,
  [NOTE_RESET_SEARCH]: noteResetSearch,
});
